import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';
import style from "../common.module.scss";
import ExportIcon from '../../../shared/icons/ExportIcon';

const ExportAviationOrders = ({ onDownloadExcel }) => {
    const { t } = useTranslation();
    const [isOpen, setIsOpen] = useState(false);
    const dropdownRef = useRef(null);

    const handleDownloadClick = () => {
        onDownloadExcel();
        setIsOpen(false);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        if (isOpen) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [isOpen]);

    return (
        <div ref={dropdownRef} className={cn(style.dropdown, { [style.dropdown_active]: isOpen })}>
            <div onClick={() => setIsOpen(!isOpen)}>
                <ExportIcon />
                <span className={style.dropdown_title}>{t('exportOrders.title')}</span>
            </div>

            <div className={cn(style.dropdowns, { [style.dropdowns_open]: isOpen })}>
                <div className={style.dropdowns_item} onClick={handleDownloadClick}>{t('exportOrders.excel')}</div>
            </div>
        </div>
    );
};

export default ExportAviationOrders;